import { useEffect, useState } from 'react';

import { useFeatureFlag } from '../components/LaunchDarklyProvider';

type UseFeatureFlagOnceReturnValue = {
  value: boolean;
  loading: boolean;
};

const useFeatureFlagOnce = (
  flagName: string,
  defaultValue: boolean,
): UseFeatureFlagOnceReturnValue => {
  const [didLoadOnce, setDidLoadOnce] = useState<boolean>(false);

  const { value, loading } = useFeatureFlag(flagName, defaultValue);

  // we don't want to re-render the app when the feature flag is already loaded and depend on the loading from useFeatureFlag
  // this is a workaround until we fix the behavior of useFeatureFlag.
  useEffect(() => {
    if (!didLoadOnce && !loading) {
      setDidLoadOnce(true);
    }
  }, [loading, didLoadOnce]);

  return {
    value,
    loading: !didLoadOnce,
  };
};

export default useFeatureFlagOnce;
